import React, { useState } from "react";
import { Grid } from "@material-ui/core";
import { BarChart } from "../../../charts/BarChart";
import { SwitchBlueGreen } from "../../../components/Switch";
import { Venda } from "../../../models/venda";
import { DashPanel } from "../DashPanel";

export interface PanelVendaPorEmpresaProps {
  vendaPorEmpresa: Venda[];
}

export const PanelVendaPorEmpresa = ({
  vendaPorEmpresa,
}: PanelVendaPorEmpresaProps) => {
  const [porValor, setPorValor] = useState(true);

  const dados = vendaPorEmpresa.map((x) => ({
    name: x.nome ?? String(x.codigo),
    value: porValor ? x.totalLiquido : x.quantidade,
  }));

  return (
    <DashPanel
      title="Venda por Empresa"
      headerAction={
        <Grid component="label" container alignItems="center" spacing={1}>
          <Grid item>(Qtd.)</Grid>
          <Grid item>
            <SwitchBlueGreen
              checked={porValor}
              onChange={(e) => setPorValor(e.target.checked)}
              name="switchEmpresaMetrica"
            />
          </Grid>
          <Grid item>R$</Grid>
        </Grid>
      }
    >
      <BarChart
        label={porValor ? "Faturamento (R$)" : "Quantidade"}
        dados={dados}
        horizontal={true}
      />
    </DashPanel>
  );
};
